import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/scrollbar";
import "assets/css/normalize.css";
import "assets/css/reset.css";
import "assets/css/fonts.css";
import "assets/css/common.css";
import "assets/css/tournament.css";
import { Provider } from "react-redux";
import { store } from "store";
import { BrowserRouter } from "react-router-dom";
import Auth0ProviderWithHistory from "components/auth/Auth0ProviderWithHistory";
import PageWebsocketWrapper from "components/page-components/PageWebsocketWrapper";
import UseitfulWrapper from "components/UseitfulWrapper";
import PageFetchUser from "components/page-components/PageFetchUser";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <Auth0ProviderWithHistory>
          <UseitfulWrapper>
            <PageFetchUser>
              <PageWebsocketWrapper>
                <App />
              </PageWebsocketWrapper>
            </PageFetchUser>
          </UseitfulWrapper>
        </Auth0ProviderWithHistory>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
